const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');

/**
 * Defines the Article-Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {articles} articles the resource defined to manage articles
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('articleViewer', ['Application', 'Authorization', 'Analyze', 'Articles', 'ContentAuth', 'Content', 'SurveyHelper', '$translate', function (Application, Authorization, Analyze, Articles, ContentAuth, Content, SurveyHelper, $translate) {
  return {
    restrict: 'E',
    scope: {
      checkFull: '@',
      fullData: '=',
      onComplete: '&',
      contentId: '=',
      specialClose: '&?',
      trackId: '=?',
      allowComments: '&?',
      journeyId: '=?'
    },
    template: require('../../templates/directives/article-viewer.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      var adminRoles = ['admin', 'creator'];
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = adminRoles.indexOf(self.user.role) !== -1;
      self.type = 'article';
      self.article = {};
      self.url = Application.navigation.getUrl();
      self.expandSurvey = false;
      self.hideSurvey = true;

      self.lightboxStatus = 'disabled';
      self.lightboxUrl = '';
      self.activateLightbox = function(url){
        self.lightboxStatus = 'enabled';
        self.lightboxUrl = url;
      };

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: self.article.surveys[0].survey_id, content_type: 'survey'});
      }
      
      self.tracking = new Application.Tracking(Analyze, moment, 'article', $scope.trackId || null);
      if (new RegExp('track').test(self.url) && !$scope.trackId) {
        var trackWatch = $scope.$watch('trackId', function(newVal) {
          if (newVal) {
            self.tracking.setTrackId($scope.trackId);
            trackWatch();
          }
        });
      } else {
        self.tracking.setTrackId($scope.trackId);
      }

      self.setInitials = function() {
        self.routeParameters = Application.navigation.getRouteParameters();
        self.url = Application.navigation.getUrl();
        self.inTrack = new RegExp('track').test(self.url) || !!$scope.trackId;
        self.inJourney = !!$scope.journeyId;
        self.inEditing = new RegExp('edit').test(self.url);
        self.contentId = $scope.contentId || self.routeParameters.id || null;
        self.article = {};
      };
      self.setInitials();

      self.displayTime = function(time) {
        var mins = ~~(time / 60);
        var secs = time % 60;

        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = time % 60;

        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
        }

        ret += "" + mins + (mins === 1 ? " min" : " mins");
        return ret;
      };

      self.addDurationWatch = function(get) {
        if (!get) {
          $scope.$watch('fullData.duration', function(newVal, oldVal) {
            if (newVal === oldVal) {
              return;
            }
            self.article.duration = $scope.fullData.duration;
          });
          return;
        }
        $scope.$watch('article.article.duration', function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          self.article.duration = self.article.duration;
        });
      };

      var setFull = function() {
        self.article = $scope.fullData;
        self.tracking.start(self.article);
        if (Application.navigation.getUrl().indexOf('edit') !== -1) {
          self.addDurationWatch();
        }
      };
      self.initialize = function () {
        if (!self.contentId && !$scope.fullData) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }

        if ($scope.checkFull) {
          if ($scope.fullData) {
            setFull();
            return;
          }
          var fullWatch = $scope.$watch('fullData', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              setFull();
              fullWatch();
            }
          }, true);
          return;
        }

        Articles.get({
          subresource: self.contentId, 
          fields: 'title,description,author,content,summary,tags,image,banner_image,user,linked_category,explore_hide,duration,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,rating_configuration,average_rating,allow_comments,groups,surveys',
          'user-populate': 'first_name,last_name,email'
        }, function (data) {
          ContentAuth.allowView(data).then(async function(allowed) {
            if(!allowed) {
              Application.messaging.addMessage({type: 'error', text: 'You don’t have permission to access this content, please contact your administrator if you believe this is a mistake', duration: 5});
              Application.navigation.back();
              return;
            }
            Analyze.record({resource: 'views'}, {content: data._id, content_type: 'article'});
            self.article = data;
            $window.document.title = self.article.title;
            self.tracking.start(self.article);
            Application.analyticsProvider.trackEvent('view', {content: data._id, content_type: 'article', title: self.article.title});

            if (self.article.average_rating) {
              self.rating = Math.round(self.article.average_rating * 5) / 100;
            }
            if ($scope.onComplete) {
              $scope.onComplete();
            } else if (self.inTrack) {
              var completeWatch = $scope.$watch('onComplete', function(newVal, oldVal){
                if (newVal && !oldVal) {
                  $scope.onComplete();
                  completeWatch();
                }
              });
            }
            if (Application.navigation.getUrl().indexOf('edit') !== -1) {
              self.addDurationWatch();
            }

            const completionContexts = [];
            if (self.inTrack && $scope.trackId) {
              completionContexts.push({key: 'track', value: $scope.trackId});
            }
            if (self.inJourney) {
              completionContexts.push({key: 'journey', value: $scope.journeyId});
            }
            Content.complete({
              type: 'article', 
              id: self.article._id,
              contexts: completionContexts
            });

            if (!!data.allow_comments && $scope.allowComments) {
              $scope.allowComments();
            }

            if (self.article.surveys?.length) {
              const hideInContext = self.inJourney || self.inTrack;
              self.hideSurvey = await SurveyHelper.hideSurvey(hideInContext, self.article.surveys[0].survey_id, self.article._id);
              $scope.$apply();
            }

          });
        }, function (error) {
          console.log('Error occured getting article ', self.contentId, error);
          Application.notifications.setError(self.translations['modules.notifications.unableToGetArticle']);
        });

      };
      self.image = function () {
        if (self.article.banner_image && self.article.banner_image.length) {
          return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + self.article.banner_image;
        }
        return '';
      };

      $translate(['modules.notifications.unableToGetArticle', 'edit.article.lessThanAMinute']).then(function(translations){
        self.translations = translations;
        self.initialize();
      });

      $scope.$on('$destroy', function() {
        self.tracking.end();
      });

      $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.setInitials();
        self.initialize();
      });

    }],
    controllerAs: 'viewer'
  };
}]);
